<template>
<CRow>
    <CCol col="12" sm="9" class="mx-auto">
        <CCard>
            <CRow>
                <CCol col="12" sm="6" class="p-0 m-0">
                    <CCardBody>
                <Form :submit="submit" :link="link" ref="linkForm" />
            </CCardBody>
                </CCol>
                <CCol col="12" sm="6" class="p-0 m-0">
                    <CCardBody>
                        <h5>عنوان چیست؟</h5>
                        <p>عنوان یک نام دلخواه است که شما برای لینک افیلیت خود در نظر می‌گیرید.</p>

                        <h5>آدرس مقصد چیست؟</h5>
                        <p>آدرس مقصد صفحه‌ای از فروشگاه است که می‌خواهید کاربر بعد از کلیک روی لینک افیلیت به آن منتقل شود.</p>
                    </CCardBody>
                </CCol>
            </CRow>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
/**
 * @deprecated
 */
import { mapGetters, mapActions } from 'vuex'
import { Form } from './partials'

export default {
    name: 'Edit',

    components: {
        Form
    },

    data() {
        return {
            id: this.$route.params.id,
        }
    },

    computed: {
        ...mapGetters('link', [
            'linkById'
        ]),
        link() {
            return this.linkById(this.id)
        }
    },
    methods: {
        ...mapActions({
            edit: 'link/edit',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        submit() {
            const linkForm = this.$refs.linkForm
            this.setShowLoading()
            this.resetMsg()

            this.edit(this.link).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.updateLink'),
                    type: 'success'
                })
            }).catch(result => {
                if(result.data) {
                    linkForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
    }
}
</script>